/* eslint-env browser */

/**
 * Simple check to determine if we're dealing with the Safari browser
 *
 * @returns {boolean}
 */
export function isSafari() { // eslint-disable-line import/prefer-default-export
  const { userAgent } = window.navigator;
  return userAgent.includes('Safari') && !userAgent.includes('Chrome');
}

export function getParentWindow() {
  if (window.opener && window.opener !== window) {
    return window.opener;
  }

  if (window.parent && window.parent !== window) {
    return window.parent;
  }

  return null;
}

export function handleBack() {
  /**
   * Safari has navigation behavior in regard to iframe that is different
   * than other browsers. In most browsers when the iframe navigates back
   * this uses the navigation history of the iframe (e.g., if I'm in a sub
   * menu of the iframe and go back one then I'm back to the iframe root
   * where I started out). On Safari, it instead will navigate the parent
   * page "back". This is highly problematic because it makes it impossible
   * to navigate back within the iframe itself. So for "normal" browsers
   * we'll just use the standard back functionality. For Safari, we will
   * instead force the iframe back to the root path.
   */
  if (isSafari() && window.self !== window.top) {
    window.location.hash = '';
    return;
  }
  // Store current URL to detect if back navigation worked
  const currentUrl = window.location.href;

  // Try to go back
  window.history.back();

  // Use a small timeout to check if navigation occurred
  setTimeout(() => {
    // If we're still on the same URL, navigation didn't work - close the window
    if (window.location.href === currentUrl) {
      window.close();
    }
  }, 100);
}

/**
 * Returns the value of the 'navbar' query parameter from the current URL.
 *
 * @returns {string|null}
 */
export function getNavbarType() {
  const params = new URLSearchParams(window.location.search);
  return params.get('navbar');
}
